import React from "react";
import AppLogo from "./assets/app-logo.png";

export const AppInfo = () => {
  return (
    <div className="app-info">
      <img src={AppLogo} alt="app logo" className="app-logo"/>
      <p className="app-name">智能家居</p>
      <p className="subtitle">创造美好智能生活</p>
    </div>
  );
}